import type { Author } from "../../types/content";

const getAuthorsEmails = (authors: Author[]) =>
  authors.reduce((emails: string[], author) => {
    const emailContact = author.contacts?.find((contact) => {
      return contact.type === "email";
    });

    if (emailContact?.value) {
      emails.push(emailContact.value);
    }

    return emails;
  }, []);

const getAuthorsNames = (authors: Author[]) =>
  authors.reduce((names: string[], author) => {
    if (author.title) {
      names.push(author.title);
    }

    return names;
  }, []);

export { getAuthorsEmails, getAuthorsNames };
